//  export const API_BASE_URL = 'https://localhost:7019';
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://digidevapi.azurewebsites.net';
// export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || 'https://vhvdigitalapi-test.azurewebsites.net/';

export const API_STATIC_DATA_REFRESH_INTERVAL = process.env.NEXT_PUBLIC_API_STATIC_DATA_REFRESH_INTERVAL || 30000    //miliseconds(5 minutes)

export const CAMPUS_VISIT_LOCATION = process.env.NEXT_CAMPUS_VISIT_LOCATION || 'Niharika Mirage, Juhi, near Medicover hospital, Sector 10, Kharghar, Maharashtra 410210';

export const CAMPUS_VISIT_LOCATION_GOOGLE_URL = process.env.NEXT_CAMPUS_VISIT_LOCATION_GOOGLE_URL || 'https://www.google.com/maps/place/Ashva+Education+Society/@19.036417,73.078619,8z/data=!4m6!3m5!1s0x3be7c355b7c64a25:0xc76b2aeb78d35d52!8m2!3d19.0364168!4d73.0786191!16s%2Fg%2F11n2gzgh9j?hl=en&entry=ttu&g_ep=EgoyMDI1MTAwOC4wIKXMDSoASAFQAw%3D%3D';


export const PRIVATE_WEBSITE_URL = process.env.NEXT_PRIVATE_WEBSITE_URL || 'https://calm-desert-08390df00.2.azurestaticapps.net/';

// Parent Portal website URLs
// Test: https://orange-field-0bcaaff00.7.azurestaticapps.net
// Prod: https://mango-sky-00a03730f.7.azurestaticapps.net
export const PRIVATE_PARENT_WEBSITE_URL = process.env.NEXT_PUBLIC_PRIVATE_PARENT_WEBSITE_URL || 'https://orange-field-0bcaaff00.7.azurestaticapps.net';
